export const PAYOUT_DETAILS_KEYS = {
  get_gst_info: "get_gst_info",
  billing_state_non_mandatory: "billing_state_non_mandatory",
  is_creator_gst_registered: "is_creator_gst_registered",
};
